module.exports = __webpack_public_path__ + "assets/img/middle.a2b36069.png";